var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScannerWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 276 280",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "square"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4,3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.419,1.407L0.419,35.747M1,1.407L37,1.407",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: 7
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,272,3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.419,1.407L0.419,35.747M1,1.407L37,1.407",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: 7
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,4,277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.419,1.407L0.419,35.747M1,1.407L37,1.407",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: 7
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,-7.65714e-16,7.65714e-16,-1,272,277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.419,1.407L0.419,35.747M1,1.407L37,1.407",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: 7
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScannerWhite);
export default __webpack_public_path__ + "static/media/scannerWhite.350331a5b1e8ebfab3001f74b03dc81b.svg";
export { ForwardRef as ReactComponent };